import { UnifiedGraftModelType } from '@graftcode/protocol'

/**
 * Re-export the protocol enum. We use the enum's KEY names (strings) for comparisons, not the numeric values.
 * UnifiedGraftModelTypeKey provides those key strings so we compare getUnifiedGraftModelType(node) === UnifiedGraftModelTypeKey.TYPE_DEF.
 */
export { UnifiedGraftModelType }

/** Enum key names as strings (the enum's key names, not values). Use for comparisons with getUnifiedGraftModelType(). */
const enumKeys = (Object.keys(UnifiedGraftModelType) as (keyof typeof UnifiedGraftModelType)[]).filter(
  (k) => typeof UnifiedGraftModelType[k] === 'number'
)
export const UnifiedGraftModelTypeKey = Object.fromEntries(enumKeys.map((k) => [k, k])) as {
  [K in (typeof enumKeys)[number]]: K
}

export type UnifiedGraftModelKey = (typeof UnifiedGraftModelTypeKey)[keyof typeof UnifiedGraftModelTypeKey]
